var map = {
	"./dashboard copy.vue": [
		2762,
		2762
	],
	"./dashboard.vue": [
		136
	],
	"./goods/edit_integral_goods.vue": [
		9387,
		9387,
		730
	],
	"./goods/editcate.vue": [
		2050,
		2050
	],
	"./goods/editgoods.vue": [
		6585,
		7172,
		2003
	],
	"./goods/goods_cate.vue": [
		5895,
		5895
	],
	"./goods/goods_list.vue": [
		8099,
		7172,
		1435
	],
	"./goods/goods_proport.vue": [
		4527,
		4527
	],
	"./goods/integral_goods.vue": [
		384,
		9387,
		2317
	],
	"./login/login copy.vue": [
		9763,
		9763
	],
	"./login/login.vue": [
		6250
	],
	"./news/editor_cate.vue": [
		543,
		543
	],
	"./news/editor_news.vue": [
		8027,
		8027,
		1642
	],
	"./news/news_cate.vue": [
		2462,
		2462
	],
	"./news/news_list.vue": [
		5680,
		8027,
		6446
	],
	"./order/exchange_order.vue": [
		1593,
		1593
	],
	"./order/order_list.vue": [
		6095,
		6095
	],
	"./power/user/editpower.vue": [
		2350,
		2350
	],
	"./power/user/editsuper.vue": [
		8575,
		8575
	],
	"./power/user/rolelist.vue": [
		6078,
		6078
	],
	"./power/user/selfpwd.vue": [
		4163,
		4163
	],
	"./power/user/superlist.vue": [
		3777,
		3777
	],
	"./power/user/superlog.vue": [
		1992,
		1992
	],
	"./setting/area_set.vue": [
		4642,
		4642
	],
	"./setting/banner_setting.vue": [
		7800,
		7800
	],
	"./setting/delivery_way.vue": [
		4255,
		4255
	],
	"./setting/edit_delivery.vue": [
		1804,
		1804
	],
	"./setting/edit_location.vue": [
		7419,
		7419
	],
	"./setting/location.vue": [
		9396,
		9396
	],
	"./setting/popup_setting.vue": [
		6892,
		6892
	],
	"./setting/qualifications.vue": [
		994,
		1470
	],
	"./setting/sys_setting.vue": [
		3786,
		3786
	],
	"./sms/index.vue": [
		2859,
		2859
	],
	"./statistics/certificate.vue": [
		8500,
		8500
	],
	"./statistics/delivery.vue": [
		5440,
		5440
	],
	"./statistics/delivery2.vue": [
		8624,
		8624
	],
	"./statistics/kuwei.vue": [
		2224,
		2224
	],
	"./statistics/material.vue": [
		6440,
		6440
	],
	"./statistics/receipt.vue": [
		4930,
		5815
	],
	"./statistics/receipt2 - 副本 (2).vue": [
		6212,
		6212
	],
	"./statistics/receipt2 - 副本 (3).vue": [
		1577,
		1577
	],
	"./statistics/receipt2 - 副本.vue": [
		2296,
		2296
	],
	"./statistics/receipt2.vue": [
		2753,
		2753
	],
	"./statistics/receipt21.vue": [
		8772,
		8772
	],
	"./statistics/receipt22.vue": [
		9723,
		9723
	],
	"./statistics/receipt23 - 副本.vue": [
		2207,
		2207
	],
	"./statistics/receipt24.vue": [
		1193,
		6697
	],
	"./statistics/receipt25.vue": [
		855,
		855
	],
	"./statistics/report/day.vue": [
		9181,
		9181
	],
	"./statistics/report/month.vue": [
		3462,
		3462
	],
	"./statistics/report/salereport.vue": [
		7813,
		7813
	],
	"./statistics/report/year.vue": [
		3938,
		3938
	],
	"./user/edituser.vue": [
		4079,
		4079
	],
	"./user/user_list.vue": [
		8687,
		8687
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2513;
module.exports = webpackAsyncContext;